import { http } from '../../../../api/axios';
import { localContentPrefix } from '../../../../config';
import { GenresListOut } from '../../../../store/apiLibx';

export const fetchLocalContentGenres = (shopLanguage: string | undefined) => {
    return http
        .get<GenresListOut>(`${localContentPrefix}/v1/marketplace/genres`, { params: { shopLanguage } })
        .then(res => res.data);
};
